import React from "react";
import PropTypes from 'prop-types';

import { Box, Tab } from "@mui/material";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import { trakrefBlue } from "../../../color_utils";
import { trakrefFontFamily, trakrefFontFamilyBold } from "../../../utils";

const TrakRefTabListStyle = {
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: trakrefBlue,
    },
    "& .MuiButtonBase-root.MuiTab-root": {
        color: "#008299 !important",
        fontSize: "13px",
        fontFamily: trakrefFontFamily,
        padding: 0,
        lineHeight: "18px",
        outline: "none",
        border: "none",
    },
    "& .MuiButtonBase-root.MuiTab-root.Mui-selected": {
        color: "#008299 !important",
        fontSize: "13px",
        fontFamily: trakrefFontFamilyBold,
        padding: 0,
        lineHeight: "18px",
    },
    "& .MuiTabs-flexContainer": {
        gap: "30px",
    },
};

const TabContainerStyle = {
  borderBottom: { xs: 'none', lg: 1 },
  borderColor: { xs:'none', lg: 'divider' },
};

const TabPanelStyle = { padding: "0px", marginTop: "15px", color: "#008299 !important" };

const Tabs = ({
    activeTab,
    onhandleChange,
    labels,
    tabElements,
    tabCustomStyle,
    tabPanelCustomStyle,
}) => {

    const handleChange = (e, newValue) => {
        const url = window.location.href.split("#")[0];
        window.history.pushState ("", "", `${url}#${newValue}`);
        onhandleChange(e, newValue)
    };

    return (
        <TabContext value={activeTab} sx={{ padding: 0, margin: 0 }}>
            <Box sx={{ ...TabContainerStyle, ...tabCustomStyle, mx: { lg: '10px !important' }}}>
                <TabList onChange={handleChange} sx={{...TrakRefTabListStyle, display: { xs: 'flex' }}}>
                    {labels.map((label, index) => (
                        <Tab
                          incid
                          key={`tab-label-${index}`}
                          label={label}
                          value={index + 1}
                        />
                    ))}
                </TabList>
            </Box>
            {tabElements.map((tab, index) => (
                <TabPanel
                    key={`tab-panel-${index}`}
                    value={index + 1}
                    sx={{ ...TabPanelStyle, ...tabPanelCustomStyle, mx: { xs: '0 !important', lg: '10px !important' } }}
                >
                    {tab}
                </TabPanel>
            ))}
        </TabContext>
    );
};

Tabs.propTypes = {
    activeTab: PropTypes.number,
    onhandleChange: PropTypes.func,
    labels: PropTypes.array,
    tabElements: PropTypes.array,
    tabCustomStyle: PropTypes.object,
    tabPanelCustomStyle: PropTypes.object,
};

Tabs.defaultProps = {
    activeTab: 0,
};

export default Tabs;
